import{useLayoutEffect as e}from"react";var n="undefined"!=typeof window,r=function(r,t){return n?e(r,t):null};export{r as default,r as useLayoutEffectBrowser};
//# sourceMappingURL=useLayoutEffectBrowser.js.map
